import { ShareButton, ShareButtonProps } from "components/tooltip-triggers";
import React from "react";

export function Share(props: ShareButtonProps) {
  return <ShareButton {...props} />;
}
